import React from 'react';
import Header from '../../Includes/Header';
import Footer from '../../Includes/Footer';
import "./SpectermProvider.css";
import provider0 from "../../Includes/Images/Group-1851.png";
import provider1 from "../../Includes/Images/Group-1850.png";
import provider2 from "../../Includes/Images/pngwing.com-1.png";
import provider3 from "../../Includes/Images/human-1.jpg";
import { Link } from 'react-router-dom';
import WideCoverage from './WideCoverage';

const SpectermInternet = () => {
    // Consistent phone number across the page
    const phoneNumber = "+1-888-348-6689";

    return (
        <>
            <Header />
            <div className="spec-container">
                <header className="spec-header1">
                    <div className="spec-logo">Spectrum</div>
                    <div className="spec-menu-toggle" id="menuToggle">☰</div>
                    <nav className="spec-nav" id="mobileNav">
                        <Link to="/spectrum" className="spec-nav-item">Spectrum</Link>
                        <Link to="/spectrum-internet" className="spec-nav-item">Spectrum INTERNET</Link>
                        <Link to="/spectrum-tv" className="spec-nav-item">Spectrum TV</Link>
                    </nav>
                </header>

                <section className="spec-hero">
                    <div className="spec-hero-content">
                        <div className="spec-ghost-text">Spectrum</div>
                        <h1 className="spec-hero-title">Fast Internet with FREE WiFi + FREE Mobile                        </h1>
                        <ul className="spec-features">
                            <li><p>Spectrum is one of the leading providers in the United States, serving state-of-the-art internet, cable TV, and phone services around 41 states.

</p></li>
                        </ul>
                        <div className="spec-price">
                            <span className="spec-dollar-sign">$</span>49.99 <span className="spec-price-month">/MO</span>
                        </div>
                        <br />
                        <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="spec-phone">
                            <i className="fas fa-phone-alt"></i> {phoneNumber}
                        </a>
                    </div>
                    <div className="spec-hero-image">
                        <img src={provider0} alt="Woman with colorful lighting" className="spec-full-image1" />
                    </div>
                </section>
            </div>

            <section className="xfnn-services">

<div className="xfnn-services-grid">
    <div className="xfnn-services-content">
        <h2 className="xfnn-services-title">Quick and Easy Internet Installation          </h2>

        <p className="xfnn-services-text">Elevate your home Internet with the speed and security you need. Get a seamless connection with plans up to 1 Gig.

        </p>
        <p className="xfnn-services-text">
            <span className="feature-check">✓</span>
            Set up your Internet in minutes with our self-install kit
        </p>

        <p className="xfnn-services-text">
            <span className="feature-check">✓</span>
            No appointment necessary</p>
        <p className="xfnn-services-text">
            <span className="feature-check">✓</span>
            Pick up your self-install kit in-store or we'll mail it to you</p>

        <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="xfnn-cta-button">
            <i className="fas fa-phone-alt"></i> {phoneNumber}
        </a>
    </div>
    <div className="xfnn-services-images">
        <div className="xfnn-image-container main-image">
            <img src={provider2} alt="Woman with colorful lighting" className="xfnn-full-image" />
        </div>
    </div>
</div>
</section>

            <div className="offers-container">
                <div className="offers-header">
                    <h2 className="spec-services-title">Experience a Fast, Secure Connection                    </h2>
                    <p>Connecting you to what matters the most!</p>
                </div>

                <div className="offers-cards">
                    {/* Basic Plan */}
                    <div className="offer-card offer-card-basic">
                        <div className="offer-header">
                            <h3 className="offer-name">Spectrum Internet®
                            </h3>
                            <p className="offer-price">$49.99 <span>/Mo</span></p>
                        </div>
                        <div className="offer-features">
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">for 12 mos with Auto Pay</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Speeds up to 300 Mbps
                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">No data caps
                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">FREE modem, FREE antivirus software
                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">No contracts. No hassles. No risks.

                                </span>
                            </div>
                        </div>
                        <div className="offer-footer">
                            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="call-button">{phoneNumber}</a>
                            <p className="disclaimer">Restrictions apply. Internet or TV req'd. Taxes extra. Pricing subj. to change</p>
                        </div>
                    </div>

                    {/* Standard Plan */}
                    <div className="offer-card offer-card-standard">
                        <div className="standard-offer-header">
                            <h3 className="offer-name">Internet Gig
                            </h3>
                            <p className="standard-offer-price">$79.99 <span>/Mo</span></p>
                        </div>
                        <div className="offer-features">
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">for 24 mos with Auto Pay

</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Speeds up to 1 Gig**
                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Get faster speeds with a 2-year price guarantee
                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">No data caps
                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">FREE modem, FREE antivirus software

                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Instant downloads of large files


                                </span>
                            </div>
                        </div>
                        <div className="offer-footer">
                            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="standard-call-button">{phoneNumber}</a>
                            <p className="disclaimer">Restrictions apply. Internet or TV req'd. Taxes extra. Pricing subj. to change</p>
                        </div>
                    </div>

                    {/* Premium Plan */}
                    <div className="offer-card offer-card-premium">
                        <div className="offer-header">
                            <h3 className="offer-name">Internet Ultra

                            </h3>
                            <p className="offer-price">$69.99 <span>/Mo</span></p>
                        </div>
                        <div className="offer-features">
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">for 24 mos with Auto Pay

</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Speeds up to 500 Mbps
                                 </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Get faster speeds with a 2-year price guarantee
                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">No data caps
                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">FREE modem, FREE antivirus software

                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Clear and uninterrupted video conferencing


                                </span>
                            </div>
                        </div>
                        <div className="offer-footer">
                            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="call-button">{phoneNumber}</a>
                            <p className="disclaimer">Restrictions apply. Internet or TV req'd. Taxes extra. Pricing subj. to change</p>
                        </div>
                    </div>
                </div>

            </div>
       <WideCoverage/>
            <Footer />
        </>
    );
};

export default SpectermInternet;